import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import apiUrl from "../constants/apiUrl";

interface Credentials { username: string; password: string; }

const authUrl = `${apiUrl}`;

export const login = createAsyncThunk(
  "auth/login",
  async (credentials: { username: string; password: string }, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${apiUrl}/auth/api/token/`, credentials);
      const { access, refresh, access_token, refresh_token } = res.data;
      // support either naming
      localStorage.setItem("access_token", access ?? access_token);
      localStorage.setItem("refresh_token", refresh ?? refresh_token);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? "Login failed");
    }
  }
);

export const logout = createAsyncThunk<void>("auth/logout", async () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
});
